// Writer project title helpers.
//
// The paper's \title{...} (writer_project_preamble, field 'title') is the
// single source of truth. A database trigger mirrors it into
// writer_projects.title as plain text, so renaming writes the preamble.

import { supabase } from '@/integrations/supabase/client';

export const UNTITLED_TITLE = 'Untitled draft';
export const MAX_TITLE_LENGTH = 80;

export const escapeTexTitle = (s: string): string =>
  s
    .replace(/\\/g, '\\textbackslash{}')
    .replace(/([&%$#_{}])/g, '\\$1')
    .replace(/~/g, '\\textasciitilde{}')
    .replace(/\^/g, '\\textasciicircum{}');

/**
 * Set the paper's title. Writes the LaTeX title (RLS owner-scoped); the
 * trigger then updates the draft name. Returns the trimmed display title.
 */
export async function renameWriterProject(
  projectId: string,
  nextTitle: string,
): Promise<string> {
  const trimmed = nextTitle.replace(/\s+/g, ' ').trim();
  if (!trimmed) throw new Error('Title cannot be empty');

  const { error } = await supabase
    .from('writer_project_preamble')
    .upsert(
      { project_id: projectId, field: 'title', value: escapeTexTitle(trimmed) },
      { onConflict: 'project_id,field' },
    );

  if (error) throw new Error(error.message);
  return trimmed.slice(0, MAX_TITLE_LENGTH);
}
